/**
 * Who currently owns focus — the one question both auth focus-restoration hooks
 * ask before moving it.
 *
 * A restore is only ever safe when nobody claimed focus in the meantime.
 * Disabling or unmounting the focused control drops `activeElement` to `<body>`
 * (`<html>` in some engines, `null` while a document is being torn down), and
 * that fall-back is the state a restore is meant to repair. A user who tabbed
 * on to another control while a ceremony was running is NOT that state, and
 * pulling focus back from a control they deliberately moved to is a worse
 * defect than the loss being repaired — so every caller checks this first.
 *
 * A named leaf rather than a shared bucket: `utils`/`helpers`/`common` are
 * banned (naming §7), and `is-record.ts` is the precedent in this directory for
 * a dependency-free predicate that two modules legitimately share.
 */
export function focusIsUnclaimed(): boolean {
  const active = document.activeElement;
  return active === null || active === document.body || active === document.documentElement;
}
